import React from 'react'
// import { Link } from 'react-router-dom';

import teamA from './Image/Teams/SHRACHI.webp';
import teamB from './Image/Teams/JSW.webp';
import teamC from './Image/Teams/Hyderabad.webp';
import teamD from './Image/Teams/Tamilnadu.webp';
import teamE from './Image/Teams/HIL.webp';
import teamF from './Image/Teams/Kalinga Lancer.webp';
import teamG from './Image/Teams/RoyalRanchi.webp';
import teamH from './Image/Teams/Delhi SG Pipers.webp';


const StandingTable = () => {
  const teams = [
    {
      name: "Vedanta Kalinga Lancers",
      logo: teamF,
      p: 3,
      w: 2,
      ws: 1,
      l: 0,
      ls: 0,
      gf: 7,
      ga: 4,
      gd: 3,
      pts: 8,
      recentForm: ["W", "W", "W"],
    },
    {
      name: "HIL GC",
      logo: teamE,
      p: 3,
      w: 2,
      ws: 0,
      l: 0,
      ls: 1,
      gf: 10,
      ga: 6,
      gd: 4,
      pts: 7,
      recentForm: ["W", "W", "L"],
    },
    {
      name: "Accord Tamil Nadu Dragons",
      logo: teamD,
      p: 3,
      w: 1,
      ws: 2,
      l: 0,
      ls: 0,
      gf: 10,
      ga: 9,
      gd: 1,
      pts: 7,
      recentForm: ["W", "W", "W"],
    },
    {
      name: "Hyderabad Toofans",
      logo: teamC,
      p: 3,
      w: 1,
      ws: 0,
      l: 0,
      ls: 2,
      gf: 7,
      ga: 6,
      gd: 1,
      pts: 5,
      recentForm: ["L", "W", "L"],
    },
    {
      name: "Ranchi Royals",
      logo: teamG,
      p: 3,
      w: 1,
      ws: 0,
      l: 2,
      ls: 0,
      gf: 8,
      ga: 8,
      gd: 0,
      pts: 3,
      recentForm: ["L", "L", "W"],
    },
    {
      name: "Shrachi Bengal Tigers",
      logo: teamA,
      p: 4,
      w: 1,
      ws: 0,
      l: 3,
      ls: 0,
      gf: 8,
      ga: 13,
      gd: -5,
      pts: 3,
      recentForm: ["W", "L", "L", "L"],
    },
    {
      name: "JSW Soorma Hockey Club",
      logo: teamB,
      p: 3,
      w: 0,
      ws: 1,
      l: 2,
      ls: 0,
      gf: 4,
      ga: 7,
      gd: -3,
      pts: 2,
      recentForm: ["L", "L", "W"],
    },
    {
      name: "SG Pipers",
      logo: teamH,
      p: 2,
      w: 0,
      ws: 0,
      l: 1,
      ls: 1,
      gf: 6,
      ga: 7,
      gd: -1,
      pts: 1,
      recentForm: ["L", "L"],
    },
  ];
  
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full shadow-md rounded-lg ">
        <thead className="bg-[#ffbd00] text-white text-center">
          <tr>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">Team</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">P</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">W</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">WS</th>  
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">L</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">LS</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">GF</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">GA</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">GD</th>
            <th className="py-1 md:px-4 px-1 border-b border-gray-200 text-center md:text-xl text-sm">PTS</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team, index) => (
            <tr key={index} className="even:bg-gray-50 ">
              <td className="md:py-2 py-1 md:px-4 px-1  text-gray-800 flex items-center justify-center ">
                <img src={team.logo} className='md:mr-2 w-12 h-auto rounded-full' alt={`${team.name} logo`} />
              </td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.p}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.w}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.ws}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.l}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.ls}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.gf}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.ga}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.gd}</td>
              <td className=" py-1 px-1 font-semibold text-md text-center">{team.pts}</td>
            </tr>
          ))}
          
        </tbody>
        
      </table>
      <p className='pt-2 text-sm'>* P - Played, W - Win, WS - Win with Shootout , L - Loss, LS - Loss with Shootout, GF - Goals For, GA - Goals Against, GD - Goals Difference, Pts - Points</p>
    </div>
  );
};

const ResultTable = () => {
  return (
    <div className='mx-auto m-2 md:px-[13.25rem] mt-14'>
      <div className="w-full bg-white shadow-md rounded-lg py-4">
      <h1 className="text-center text-3xl font-bold my-2 mb-6 text-[#3b0067]">Standings </h1>
        <StandingTable />
      </div>
    </div>
    
  )
}

export default ResultTable